import React from 'react'
import { VscError } from "react-icons/vsc";

function LogError({ error = null }) {
    return (
        <>
            {error && (
                <div className="text-red-500 text-sm my-5 flex gap-2 items-center capitalize justify-center">
                    <VscError />
                    {error?.response?.data || "Unknown error"}
                </div>
            )}
        </>
    )
}

export default LogError